import request from '#api/axios';
import { queryKeyFactory } from '#api/queryKeyFactory';
import {
  IGetCoachAllRecords,
  IPostRecord,
  LectureRecord
} from '#types/records';
import { UseQueryOptions, useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

export const getRecords = async (registeredLectureId: string) => {
  const res = await request<LectureRecord>({
    method: 'get',
    url: `/records/${registeredLectureId}`
  });

  return res.data;
};

export const useGetRecords = (
  registeredLectureId: string,
  options?: UseQueryOptions<LectureRecord, AxiosError, LectureRecord, string[]>
) => {
  return useQuery(
    queryKeyFactory.GET_RECORDS(registeredLectureId),
    () => getRecords(registeredLectureId),
    {
      enabled: !!registeredLectureId,
      ...options
    }
  );
};

export const postRecord = async ({
  registeredLectureId,
  payload
}: {
  registeredLectureId: string;
  payload: IPostRecord;
}) => {
  const res = await request({
    method: 'post',
    url: `/records/${registeredLectureId}`,
    data: payload
  });

  return res.data;
};

export const patchRecord = async ({
  registeredLectureId,
  payload
}: {
  registeredLectureId: string;
  payload: IPostRecord;
}) => {
  const res = await request({
    method: 'patch',
    url: `/records/${registeredLectureId}`,
    data: payload
  });

  return res.data;
};

export const getCoachAllRecords = async ({
  page,
  offset
}: {
  page?: number;
  offset?: number;
} = {}) => {
  const res = await request<IGetCoachAllRecords>({
    method: 'get',
    url: '/records',
    params: {
      page,
      offset
    }
  });

  return res.data;
};

export const deleteMediaFiles = async (
  registeredLectureId: string,
  data: string[]
) => {
  const res = await request({
    method: 'delete',
    url: `/records/${registeredLectureId}/all/exercise-images`,
    data: data
  });
  return res.data;
};

export const useGetCoachAllRecords = ({
  page,
  offset
}: {
  page?: number;
  offset?: number;
} = {}) => {
  return useQuery(queryKeyFactory.GET_COACH_ALL_RECORDS({ page, offset }), () =>
    getCoachAllRecords({ page, offset })
  );
};

/**
 * 운동차트 고도화 작업 이후에 작성된 new 버전 최신 운동차트(이 경우 exerciseTypeId가 null이 아님)의 registeredLectureId 확인.
 * null이면 new 버전 운동차트가 없으므로 새로 작성 필요
 * @returns
 */
export const getRecordV2 = async (registeredLectureId: string) => {
  const res = await request<string | null>({
    method: 'get',
    url: `/records/new-version/register-lecture-id`
  });

  return res.data;
};
